import { get, destroy, postRaw } from '.';

export function GetAssets(options = {}) {
	return get<any>("/app/api/assets", options);
}

export function FindAsset(assetId: string, options = {}) {
	return get<any>(`/app/api/assets/${assetId}`, options);
}

export function CreateAssets(options = {}) {
	return postRaw<any>("/app/api/assets", options);
}

export function DestroyAsset(id: string, options = {}) {
	return destroy<any>(`/app/api/assets/${id}`, options);
}